(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lcu-audio-preview"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var TRACK_MAX = 1000;
    var container = document.getElementById('lcu-audio-preview');
    if (!container) return;

    // ─── Toggle accordion ─────────────────────────────────────
    var toggleBtn = container.querySelector('.lcu-audio-preview__toggle');
    var body = document.getElementById('lcu-audio-preview-body');

    if (toggleBtn && body) {
      toggleBtn.addEventListener('click', function () {
        var isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          // Fermer : pause audio en cours
          container.querySelectorAll('.lcu-audio__element').forEach(function (a) {
            if (!a.paused) a.pause();
          });
          body.hidden = true;
          toggleBtn.setAttribute('aria-expanded', 'false');
        } else {
          body.hidden = false;
          toggleBtn.setAttribute('aria-expanded', 'true');
        }
      });
    }

    var cards = container.querySelectorAll('.lcu-audio-preview__card');
    var dots = container.querySelectorAll('.lcu-audio-preview__dot');
    var total = cards.length;
    var current = 0;

    function fmt(s) {
      var m = Math.floor(s / 60);
      var ss = Math.floor(s % 60);
      return m + ':' + (ss < 10 ? '0' : '') + ss;
    }

    function stopAll(except) {
      document.querySelectorAll('.lcu-audio__element').forEach(function (a) {
        if (a !== except && !a.paused) {
          a.pause();
          var card = a.closest('.lcu-audio-preview__card') || a.closest('.lcu-audio__card');
          if (card) {
            var btn = card.querySelector('.lcu-audio__play');
            if (btn) {
              btn.dataset.playing = 'false';
              var iconPlay = btn.querySelector('.lcu-audio__icon-play');
              var iconPause = btn.querySelector('.lcu-audio__icon-pause');
              if (iconPlay) iconPlay.removeAttribute('hidden');
              if (iconPause) iconPause.setAttribute('hidden', '');
            }
          }
        }
      });
    }

    function initCard(card) {
      if (card.dataset.audioInit === 'true') return;
      card.dataset.audioInit = 'true';

      var audio = card.querySelector('.lcu-audio__element');
      var btn = card.querySelector('.lcu-audio__play');
      var track = card.querySelector('.lcu-audio__track');
      var curr = card.querySelector('.lcu-audio__current');
      var dur = card.querySelector('.lcu-audio__duration');

      var isScrubbing = false;
      var pendingSeekValue = null;

      if (!btn || !audio) return;
      if (track) { track.value = 0; track.style.setProperty('--progress', '0%'); }

      function setTrackValue(v) {
        if (!track) return;
        var safe = Math.max(0, Math.min(TRACK_MAX, Math.round(v)));
        track.value = safe;
        track.style.setProperty('--progress', ((safe / TRACK_MAX) * 100) + '%');
      }

      function syncUi(t) {
        if (!audio.duration || !isFinite(audio.duration)) return;
        var safe = Math.max(0, Math.min(t, audio.duration));
        setTrackValue((safe / audio.duration) * TRACK_MAX);
        if (curr) curr.textContent = fmt(safe);
      }

      function seekTo(v) {
        var safe = Math.max(0, Math.min(TRACK_MAX, Number(v) || 0));
        setTrackValue(safe);
        if (!audio.duration || !isFinite(audio.duration)) { pendingSeekValue = safe; return; }
        pendingSeekValue = null;
        var nextTime = (safe / TRACK_MAX) * audio.duration;
        if (curr) curr.textContent = fmt(nextTime);
        audio.currentTime = nextTime;
      }

      function finishScrub() { isScrubbing = false; syncUi(audio.currentTime); }

      audio.addEventListener('loadedmetadata', function () {
        if (dur) dur.textContent = fmt(audio.duration);
        if (pendingSeekValue !== null) { seekTo(pendingSeekValue); return; }
        syncUi(audio.currentTime);
      });
      audio.addEventListener('durationchange', function () {
        if (dur && audio.duration && isFinite(audio.duration)) dur.textContent = fmt(audio.duration);
        syncUi(audio.currentTime);
      });
      audio.addEventListener('timeupdate', function () { if (!isScrubbing) syncUi(audio.currentTime); });
      audio.addEventListener('seeked', function () { if (!isScrubbing) syncUi(audio.currentTime); });

      audio.addEventListener('play', function () {
        btn.dataset.playing = 'true';
        var ip = btn.querySelector('.lcu-audio__icon-play');
        var ipa = btn.querySelector('.lcu-audio__icon-pause');
        if (ip) ip.setAttribute('hidden', '');
        if (ipa) ipa.removeAttribute('hidden');
      });
      audio.addEventListener('pause', function () {
        if (audio.ended) return;
        btn.dataset.playing = 'false';
        var ip = btn.querySelector('.lcu-audio__icon-play');
        var ipa = btn.querySelector('.lcu-audio__icon-pause');
        if (ip) ip.removeAttribute('hidden');
        if (ipa) ipa.setAttribute('hidden', '');
      });
      audio.addEventListener('ended', function () {
        pendingSeekValue = null; isScrubbing = false;
        btn.dataset.playing = 'false';
        var ip = btn.querySelector('.lcu-audio__icon-play');
        var ipa = btn.querySelector('.lcu-audio__icon-pause');
        if (ip) ip.removeAttribute('hidden');
        if (ipa) ipa.setAttribute('hidden', '');
        audio.currentTime = 0;
        if (curr) curr.textContent = '0:00';
        setTrackValue(0);
      });

      if (track) {
        track.addEventListener('pointerdown', function () { isScrubbing = true; });
        track.addEventListener('input', function () { isScrubbing = true; seekTo(track.value); });
        track.addEventListener('change', function () { seekTo(track.value); finishScrub(); });
        track.addEventListener('pointerup', finishScrub);
        track.addEventListener('pointercancel', finishScrub);
        track.addEventListener('keyup', function () { seekTo(track.value); finishScrub(); });
      }

      btn.addEventListener('click', function () {
        if (audio.paused) {
          stopAll(audio);
          var p = audio.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function () {
              btn.dataset.playing = 'false';
              var ip = btn.querySelector('.lcu-audio__icon-play');
              var ipa = btn.querySelector('.lcu-audio__icon-pause');
              if (ip) ip.removeAttribute('hidden');
              if (ipa) ipa.setAttribute('hidden', '');
            });
          }
        } else {
          audio.pause();
        }
      });
    }

    cards.forEach(initCard);

    function showSlide(index) {
      var prevAudio = cards[current].querySelector('.lcu-audio__element');
      if (prevAudio && !prevAudio.paused) prevAudio.pause();

      current = ((index % total) + total) % total;

      cards.forEach(function (c) { c.classList.remove('is-current'); });
      cards[current].classList.add('is-current');

      dots.forEach(function (d) { d.classList.remove('is-active'); });
      if (dots[current]) dots[current].classList.add('is-active');
    }

    container.addEventListener('click', function (e) {
      var arrow = e.target.closest('[data-dir]');
      if (!arrow) return;
      showSlide(current + (arrow.dataset.dir === 'next' ? 1 : -1));
    });

    var bridgeCta = container.querySelector('[data-lcu-bridge]');
    if (bridgeCta) {
      bridgeCta.addEventListener('click', function (e) {
        var href = bridgeCta.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var firstInput = target.querySelector('input, textarea, select');
        if (firstInput) {
          setTimeout(function () { try { firstInput.focus({ preventScroll: true }); } catch (err) { firstInput.focus(); } }, 500);
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
